import { useState, useEffect } from "react";
import {
  signOut,
  saveReview,
  saveReferral,
  saveBreach,
  getUserValue,
  getAllValue,
  getClaims,
  getUserClaims,
} from "../../action";
import { jwtDecode } from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import { pointsManager, getAllReviewData } from "../../action";

export const Header = ({ role }) => {
  const dispatch = useDispatch();
  const jwtToken = localStorage.getItem("jwtToken");

  const [showGoogleReviewModal, setShowGoogleReviewModal] = useState(false);
  const [showReferralModal, setShowReferralModal] = useState(false);
  const [showBreachModal, setShowBreachModal] = useState(false);
  const [showPointManagerModal, setShowPointManagerModal] = useState(false);

  const [reviewDate, setReviewDate] = useState("");
  const [reviewStar, setReviewStar] = useState(0);
  const [reviewContent, setReviewContent] = useState("");

  const [referralName, setReferralName] = useState("");
  const [referralAddress, setReferralAddress] = useState("");
  const [referralPhoneNumber, setReferralPhoneNumber] = useState("");

  const [recordedBreach, setRecordedBreach] = useState(false);
  const [insurerName, setInsurerName] = useState("");
  const [typeOfBreach, setTypeOfBreach] = useState("");
  const [recordedDate, setRecordedDate] = useState("");
  const [emailDate, setEmailDate] = useState("");
  const [userId, setUserId] = useState("");
  const [userName, setUserName] = useState("admin");
  const [pointType, setPointType] = useState(false);
  const [pointsAmount, setPointsAmount] = useState(0);

  const state = useSelector((state) => state.reducer);

  useEffect(() => {
    if (jwtToken) {
      try {
        const decoded = jwtDecode(jwtToken);
        if (decoded && decoded.id) {
          setUserId(decoded.id);
        } else {
          console.log("ID not found in decoded JWT");
        }
      } catch (error) {
        console.error("Error decoding the token:", error);
      }
    } else {
      console.log("No JWT token found in localStorage.");
    }
  }, [jwtToken]);

  const handleSubmit = () => {
    // Here you can dispatch to Redux or send to backend
    dispatch(saveReview(userId, reviewDate, reviewStar, reviewContent));

    setShowGoogleReviewModal(false);
  };

  return (
    <>
      <header
        className={
          role === 0
            ? `bg-blue-800 text-white p-4 shadow-md`
            : `bg-green-700 text-white p-4 shadow-md`
        }
      >
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div className="flex items-center gap-3">
            <div className="bg-white text-blue-800 rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm">
              CD
            </div>
            <div>
              <h1 className="font-bold text-lg">CLAIM DEFENDER A.I</h1>
              <p className="text-xs opacity-80">CLAIM TRACKER</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            {role == 0 ? (
              <>
                <button
                  className="bg-white text-blue-800 hover:bg-blue-100 font-medium px-4 py-2 rounded-md transition duration-200 shadow"
                  onClick={() => {
                    setShowBreachModal(true);
                  }}
                >
                  Breach
                </button>
                <button
                  onClick={() => setShowGoogleReviewModal(true)}
                  className="bg-white text-blue-800 hover:bg-blue-100 font-medium px-4 py-2 rounded-md transition duration-200 shadow"
                >
                  Google Review
                </button>
                <button
                  className="bg-white text-blue-800 hover:bg-blue-100 font-medium px-4 py-2 rounded-md transition duration-200 shadow"
                  onClick={() => setShowReferralModal(true)}
                >
                  Referral
                </button>
              </>
            ) : (
              <>
                <select
                  className="w-[200px] max-w-xs px-4 py-2 border-2 border-green-500 rounded-xl shadow-md
                      bg-green-50 text-green-800 font-semibold tracking-wide
                      focus:outline-none focus:ring-4 focus:ring-green-300 
                      hover:shadow-lg 
                      transition duration-300 ease-in-out animate-fade-in-down cursor-pointer"
                  defaultValue=""
                  onChange={(e) => {
                    dispatch(getAllReviewData(e.target.value));
                    setUserName(e.target.value);
                    dispatch(getUserValue(e.target.value));
                    dispatch(getUserClaims(e.target.value));
                  }}
                >
                  <option value="" disabled>
                    Users
                  </option>
                  {state.userNames.map((user, index) => (
                    <option
                      key={index}
                      value={user.userName}
                      className="bg-white text-green-800 hover:bg-green-100 transition duration-150 cursor-pointer"
                    >
                      {user.userName}
                    </option>
                  ))}
                </select>
                <button
                  className="bg-white text-blue-800 hover:bg-blue-100 font-medium px-4 py-2 rounded-md transition duration-200 shadow"
                  onClick={() => setShowPointManagerModal(true)}
                  disabled={userName === "admin"}
                >
                  Point Manager
                </button>

                <button
                  className="bg-white text-blue-800 hover:bg-blue-100 font-medium px-4 py-2 rounded-md transition duration-200 shadow"
                  onClick={() => {
                    setUserName("admin");
                    dispatch(getAllValue());
                  }}
                >
                  Admin View
                </button>
              </>
            )}

            <button
              onClick={() => dispatch(signOut())}
              className="bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-md transition duration-200 shadow"
            >
              Sign Out
            </button>
          </div>
        </div>
      </header>
      {/* google review modal */}
      {showGoogleReviewModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
          onClick={() => setShowGoogleReviewModal(false)}
        >
          <div
            className="bg-white p-6 rounded-xl shadow-2xl w-full max-w-lg mx-4 relative animate-fade-in-up"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 border-b pb-2">
              Google Review Entry
            </h2>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Google Review Received Date
                </label>
                <input
                  type="date"
                  name="date"
                  value={reviewDate}
                  onChange={(e) => setReviewDate(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Google Review Star Number
                </label>
                <input
                  type="number"
                  name="stars"
                  value={reviewStar}
                  onChange={(e) => setReviewStar(e.target.value)}
                  min="1"
                  max="5"
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Google Review Content
                </label>
                <textarea
                  name="content"
                  value={reviewContent}
                  onChange={(e) => setReviewContent(e.target.value)}
                  rows="4"
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                ></textarea>
              </div>
            </div>

            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => setShowGoogleReviewModal(false)}
                className="px-4 py-2 rounded-md bg-gray-100 hover:bg-gray-200 text-gray-700 transition"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white font-semibold transition"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Referral modal */}
      {showReferralModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
          onClick={() => setShowReferralModal(false)}
        >
          <div
            className="bg-white p-6 rounded-xl shadow-2xl w-full max-w-lg mx-4 relative animate-fade-in-up"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 border-b pb-2">
              Referral Entry
            </h2>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Name
                </label>
                <input
                  type="text"
                  name="date"
                  value={referralName}
                  onChange={(e) => setReferralName(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Address
                </label>
                <input
                  type="text"
                  name="stars"
                  value={referralAddress}
                  onChange={(e) => setReferralAddress(e.target.value)}
                  min="1"
                  max="5"
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Phone number
                </label>
                <input
                  name="text"
                  value={referralPhoneNumber}
                  onChange={(e) => setReferralPhoneNumber(e.target.value)}
                  rows="4"
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                ></input>
              </div>
            </div>

            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => setShowReferralModal(false)}
                className="px-4 py-2 rounded-md bg-gray-100 hover:bg-gray-200 text-gray-700 transition"
              >
                Cancel
              </button>
              <button
                onClick={(e) => {
                  dispatch(
                    saveReferral(
                      userId,
                      referralName,
                      referralAddress,
                      referralPhoneNumber
                    )
                  );
                  setShowReferralModal(false);
                }}
                className="px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white font-semibold transition"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Rreach Modal */}
      {showBreachModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
          onClick={() => setShowBreachModal(false)}
        >
          <div
            className="bg-white p-6 rounded-xl shadow-2xl w-full max-w-lg mx-4 relative animate-fade-in-up"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 border-b pb-2">
              Breach Entry
            </h2>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  1. Did you record the breach in the 'insurer breach'
                  spreadsheet?
                </label>
                <div className="flex gap-6">
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      name="recorded"
                      value="yes"
                      checked={recordedBreach === true}
                      onChange={(e) => setRecordedBreach(true)}
                      className="text-blue-600 focus:ring-blue-500"
                    />
                    <span className="ml-2 text-gray-700">Yes</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      name="recorded"
                      value="no"
                      checked={recordedBreach === false}
                      onChange={(e) => setRecordedBreach(false)}
                      className="text-blue-600 focus:ring-blue-500"
                    />
                    <span className="ml-2 text-gray-700">No</span>
                  </label>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  2. What was the name of the insurer, the type of breach, the
                  date you recorded it?
                </label>
                <label className="inline-flex items-center mb-2">
                  <span className="ml-2 text-gray-700 mr-[10px]">Name</span>
                  <input
                    type="text"
                    name="insurerName"
                    value={insurerName}
                    onChange={(e) => setInsurerName(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </label>
                <label className="inline-flex items-center mb-2">
                  <span className="ml-2 text-gray-700  mr-[20px]">Type</span>
                  <input
                    type="text"
                    name="typeOfBreach"
                    value={typeOfBreach}
                    onChange={(e) => setTypeOfBreach(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </label>
                <label className="inline-flex items-center">
                  <span className="ml-2 text-gray-700  mr-[20px]">Date</span>
                  <input
                    type="date"
                    name="recordedDate"
                    value={recordedDate}
                    onChange={(e) => setRecordedDate(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </label>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  3. what date did you email accounts@dragonroofrestoration.com
                  that you had recorded the breach?
                </label>
                <input
                  type="date"
                  name="emailDate"
                  value={emailDate}
                  onChange={(e) => setEmailDate(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => setShowBreachModal(false)}
                className="px-4 py-2 rounded-md bg-gray-100 hover:bg-gray-200 text-gray-700 transition"
              >
                Cancel
              </button>
              <button
                onClick={(e) => {
                  dispatch(
                    saveBreach(
                      userId,
                      recordedBreach,
                      insurerName,
                      typeOfBreach,
                      recordedDate,
                      emailDate
                    )
                  );
                  setShowBreachModal(false);
                }}
                className="px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white font-semibold transition"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      {showPointManagerModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
          onClick={() => setShowPointManagerModal(false)}
        >
          <div
            className="bg-white p-6 rounded-xl shadow-2xl w-full max-w-lg mx-4 relative animate-fade-in-up"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 border-b pb-2">
              Point Manager
            </h2>

            <div className="space-y-4">
              <div>
                <div className="flex gap-6">
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      name="addpoints"
                      value="yes"
                      checked={pointType === true}
                      onChange={(e) => setPointType(true)}
                      className="text-blue-600 focus:ring-blue-500"
                    />
                    <span className="ml-2 text-gray-700">Add Points</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      name="removepoints"
                      value="no"
                      checked={pointType === false}
                      onChange={(e) => setPointType(false)}
                      className="text-blue-600 focus:ring-blue-500"
                    />
                    <span className="ml-2 text-gray-700">Remove Points</span>
                  </label>
                </div>
              </div>

              <div>
                {/* <label className="inline-flex items-center mb-2">
                    <span className="ml-2 text-gray-700 mr-[10px]">Name</span>
                    <input
                      type="text"
                      name="insurerName"
                      value={insurerName}
                      onChange={(e) => setInsurerName(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </label> */}
                <label className="inline-flex items-center mb-2">
                  <input
                    type="number"
                    name="pointsAmount"
                    value={pointsAmount}
                    onChange={(e) => setPointsAmount(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <span className="ml-2 text-gray-700  mr-[20px]">Points</span>
                </label>
              </div>
            </div>

            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => setShowPointManagerModal(false)}
                className="px-4 py-2 rounded-md bg-gray-100 hover:bg-gray-200 text-gray-700 transition"
              >
                Cancel
              </button>
              <button
                onClick={(e) => {
                  dispatch(pointsManager(userName, pointType, pointsAmount));
                  setShowPointManagerModal(false);
                }}
                className="px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white font-semibold transition"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
